import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const LastVisitedProduct = () => {
    const [lastProducts, setLastProducts] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const products = JSON.parse(localStorage.getItem("lastVisitedProducts")) || [];
        setLastProducts(products);
    }, []);

    if (lastProducts.length === 0) return null;

    return (
        <div className=" md:px-6 my-8 ">
          <h2 className=" text-center font-poppins mb-2 text-black md:text-3xl text-2xl font-semibold">Recently Visited Products</h2>
         

            <section className="text-gray-600 body-font">
                <div className=" px-5 py-5">
                    <div className="flex flex-wrap  md:-m-4">
                        {lastProducts.map((item, index) => {
                            const { id, title, price, productImageUrl, reviews, discount } = item;

                            const images = Array.isArray(productImageUrl)
                                ? productImageUrl
                                : productImageUrl
                                    ? [productImageUrl]
                                    : [];

              
                            return (
                                <div key={index} className="p-3 ">
                                    <div className="relative  bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">

                                        {/* Discount Badge */}
                                        {discount && (
                                            <div className="absolute top-2 left-2 bg-yellow-400 text-xs font-semibold px-2 py-1 rounded">
                                                {discount}% OFF
                                            </div>
                                        )}

                                        {/* Product Image */}
                                        <div className="flex justify-center  bg-white ">
                                            {images?.[0] && (
                                                <img
                                                    src={images[0]}
                                                    alt="Product "
                                                   
                                                    className="card h-[280px] w-[300px] object-cover cursor-pointer"
                                                />
                                            )}
                                        </div>

                                        {/* Product Info */}
                                        <div className="p-4 text-center">
                                            <h2 className="text-xs font-poppins text-gray-500 mb-1 uppercase tracking-wider">Durapot</h2>
                                            <h1 className="text-lg font-outfit font-medium text-gray-900 mb-2">
                                                {title.substring(0, 25)}
                                            </h1>

                                            {/* Price Display */}
                                            <div className="flex justify-center items-center space-x-2 mb-2">
                                                <span className="text-gray-500 line-through  font-outfit text-lg font-medium">
                                                    ₹{Math.round(price * 1.10)}
                                                </span>
                                                <span className="text-green-700 italic  font-outfit text-lg font-medium">₹{price}</span>
                                            </div>

                                            {/* Review Display */}
                                            {reviews && (
                                                <div className="flex justify-center items-center text-sm text-green-700 mb-3">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="currentColor"
                                                        className="w-4 h-4 mr-1"
                                                        viewBox="0 0 20 20"
                                                    >
                                                        <path d="M10 15l-5.878 3.09 1.122-6.545L.488 6.91l6.561-.954L10 0l2.951 5.956 6.561.954-4.756 4.635 1.122 6.545z" />
                                                    </svg>
                                                    <span>{reviews.rating} ({reviews.count} Reviews)</span>
                                                </div>
                                            )}

                                            <button
                                className="text-white w-full py-2 rounded-lg bg-green-600 hover:bg-green-700 font-semibold font-outfit"
                                onClick={() => navigate(`/productinfo/${id}`)}
                            >
                                View
                            </button>
                                          
                                          
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>



        </div>
    );
};

export default LastVisitedProduct;
